import { render, staticRenderFns } from "./ApplicantChart2.vue?vue&type=template&id=506627fc&scoped=true&"
import script from "./ApplicantChart2.vue?vue&type=script&lang=js&"
export * from "./ApplicantChart2.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantChart2.vue?vue&type=style&index=0&id=506627fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506627fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VContainer,VRow,VSimpleTable})
